import { useState } from "react";
import { Formik, Form } from "formik";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import AddForm from "../components/AddForm";
import AttachmentForm from "../components/AttachmentForm";
import BugdetForm from "../components/BudgetForm";
import validations from "../schemas/validations";
import form from "../schemas/form";
import initialValues from "../schemas/initialValues";
import { RequestService } from "services/RequestService";
import MDSnackbar from "components/MDSnackbar";
import { useNavigate } from "react-router-dom";

function getSteps() {
  return ["معلومات المشروع", "الميزانية", "المرفقات"];
}

function getStepContent(stepIndex, formData) {
  switch (stepIndex) {
    case 0:
      return <AddForm formData={formData} />;
    case 1:
      return <BugdetForm formData={formData} />;
    case 2:
      return <AttachmentForm formData={formData} />;
    default:
      return null;
  }
}

function AddProject() {
  const [activeStep, setActiveStep] = useState(0);
  const steps = getSteps();
  const { formId, formField } = form;
  const currentValidation = validations[activeStep];
  const isLastStep = activeStep === steps.length - 1;
  const [show, setShow] = useState(false);
  const [error, setError] = useState(false);
  const toggleSnackbar = () => setShow(!show);
  const toggleSnackbar2 = () => setError(!error);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const handleBack = () => setActiveStep(activeStep - 1);

  const submitForm = async (values, actions) => {
    try {
      // Don't set loading state here since isSubmitting handles it
      console.log("Submitting values:", values); // للتحقق من البيانات المرسلة
      
      const result = await RequestService.postFormData("Project", values);
      
      setMessage(result.data.message);
      if (result.status === 200) {
        setShow(true);
        await sleep(1000);
        navigate("/pages/projects/viewprojects");
      } else {
        setError(true);
      }
    } catch (errorResponse) {
      console.error("Submit error:", errorResponse); // للتحقق من نوع الخطأ
      if (errorResponse.response?.data?.Message) {
        setMessage(errorResponse.response.data.Message);
      } else if (errorResponse.response?.data?.message) {
        setMessage(errorResponse.response.data.message);
      } else {
        setMessage("حدث خطأ غير متوقع");
      }
      setError(true);
    } finally {
      actions.setSubmitting(false);
      actions.resetForm();
      setActiveStep(0);
    }
  };

  const handleSubmit = (values, actions) => {
    console.log("Handle submit called", { isLastStep, activeStep, values });
    
    if (isLastStep) {
      console.log("Submitting form...");
      submitForm(values, actions);
    } else {
      console.log("Moving to next step...");
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  };

  return (
    <DashboardLayout>
      <MDSnackbar
        color="success"
        icon="notifications"
        title="تمت العملية بنجاح"
        content={message}
        dateTime="منذ 0 ثانية"
        open={show}
        close={toggleSnackbar}
      />
      <MDSnackbar
        color="error"
        icon="notifications"
        title="فشلت العملية"
        content={message}
        dateTime="منذ 0 ثانية"
        open={error}
        close={toggleSnackbar2}
      />
      <DashboardNavbar />
      <MDBox py={3} mb={20} height="65vh">
        <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%", mt: 8 }}>
          <Grid item xs={12} lg={8}>
            <Formik
              initialValues={initialValues}
              validationSchema={currentValidation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setValues, setFieldValue, isValid }) => (
                <Form id={formId} autoComplete="off">
                  <Card sx={{ height: "100%" }}>
                    <MDBox mx={2} mt={-3}>
                      <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((label) => (
                          <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                          </Step>
                        ))}
                      </Stepper>
                    </MDBox>
                    <MDBox p={3}>
                      <MDBox>
                        {getStepContent(activeStep, {
                          values,
                          touched,
                          formField,
                          errors,
                          setValues,
                          setFieldValue,
                        })}
                        <MDBox mt={2} width="100%" display="flex" justifyContent="space-between">
                          {activeStep === 0 ? (
                            <MDBox />
                          ) : (
                            <MDButton variant="gradient" color="light" onClick={handleBack}>
                              السابق
                            </MDButton>
                          )}
                          <MDButton
                            disabled={isSubmitting}
                            type="submit"
                            variant="gradient"
                            color="dark"
                          >
                            {isLastStep ? "إرسال" : "التالي"}
                          </MDButton>
                        </MDBox>
                        {/* إضافة معلومات التطوير للتحقق من الحالة */}
                        {process.env.NODE_ENV === 'development' && (
                          <MDBox mt={2} style={{ fontSize: '12px', color: '#666' }}>
                            Debug: isSubmitting={isSubmitting.toString()}, isValid={isValid.toString()}, 
                            hasErrors={Object.keys(errors).length > 0 ? 'true' : 'false'}
                          </MDBox>
                        )}
                      </MDBox>
                    </MDBox>
                  </Card>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default AddProject;
